import React from 'react';
import { Box, Inscription, List } from '@common-fe/common-fe';

import { CATEGORY_NAME_OFFSET } from '../Services.constants';

interface CategoriesTableProps {
  children: React.ReactNode;
}

const CategoriesTable: React.FC<CategoriesTableProps> = ({ children }) => {
  return (
    <Box
      data-testid="services_categories-list"
      direction="column"
      background="module"
      round="moduleRound"
      pad="spacing24"
      gap="spacing8"
    >
      <List.Header>
        <List.Header.Item style={{ width: '50%', paddingLeft: CATEGORY_NAME_OFFSET }}>
          <Inscription size="12px" weight="bold" lineHeight="18px">
            Category name
          </Inscription>
        </List.Header.Item>
        <List.Header.Item style={{ width: '50%' }}>
          <Inscription size="12px" weight="bold" lineHeight="18px">
            Number of services
          </Inscription>
        </List.Header.Item>
      </List.Header>
      {children}
    </Box>
  );
};

export default CategoriesTable;
